import React from 'react';

import MinusIcon from '../../assets/images/minus.svg';
import PlusIcon from '../../assets/images/plus.svg';

import './styles.css';

const Component = (props) => {
  let icon = null;
  let message = null;
  if (props.type === 'add') {
    icon = PlusIcon;
    message = 'Add trusted contact person';
  } else {
    icon = MinusIcon;
    message = 'Remove trusted contact person';
  }
  return (
    <button onClick={() => props.onClick()} type="button" styleName="trustedContactToggleBtn">
      <img width="12" src={icon} alt="trusted contact person toggle icon" />
      <span>{message} (Optional)</span>
    </button>
  );
};

Component.displayName = 'TrustedContactToggle';

export default Component;



// WEBPACK FOOTER //
// ./src/components/SignUp/TrustedContactToggle.js